import { z } from 'zod'

export const RecommendationSchemaStatus = z.object({
  id: z.number(),
  value: z.string(),
  display_value: z.string(),
  color: z.string()
})

export const RecommendationSchema = z.object({
  next_edition_coordinator_recommendation_status: RecommendationSchemaStatus.nullish(),
  next_edition_application_status: RecommendationSchemaStatus.nullish()
})
